import React from 'react';
import EmailSentLogo from '@design-system/Assets/email-sent.png';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { EmailSentCardContainer, Background, Card, Text } from '@design-system/';

const EmailSentCard = styled.img`
  display: block;
  margin: auto;

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`;

const EmailSent = () => {
  return (
    <Background>
      <EmailSentCardContainer>
        <Card style={{ paddingBottom: 30 }}>
          <EmailSentCard src={EmailSentLogo} />
          <Text size="large">Email has been sent</Text>
          <Text
            size="small"
            style={{ TextAlign: 'center', width: '70%', margin: 'auto' }}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neque
          </Text>
          <Text size="small" color="black" style={{ marginTop: '15%' }}>
            Didn’t receive the mail?{' '}
            <Link style={{ textDecoration: 'none', color: '#fbd560' }} to="">
              Resend
            </Link>
          </Text>
        </Card>
      </EmailSentCardContainer>
    </Background>
  );
};
export default EmailSent;
